/* eslint-disable no-bitwise */

// [Flags]
export enum NotificationChannel {
    Portal = 1 << 0,
    Email = 1 << 1,
    Sms = 1 << 2,
}

// eslint:disable
